(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
    var dots = track.parentElement.querySelectorAll('[data-carousel-dot]');

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    if (dots.length) {
      track.addEventListener('scroll', function () {
        var i = current();
        dots.forEach(function (dot, j) {
          if (j === i) {
            dot.setAttribute('data-active', '');
          } else {
            dot.removeAttribute('data-active');
          }
        });
      });
    }

    var every = parseInt(track.dataset.carouselTrack, 10);
    if (!every) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var paused = false;
    track.addEventListener('pointerenter', function () { paused = true; });
    track.addEventListener('pointerleave', function () { paused = false; });

    var timer = setInterval(function () {
      if (paused || !track.clientWidth) return;
      var last = track.scrollWidth - track.clientWidth;
      // Within a pixel of the end counts as the end: scrollLeft is fractional
      // once the browser has snapped, so an exact comparison never matches.
      var next = track.scrollLeft >= last - 1 ? 0 : (current() + 1) * track.clientWidth;
      track.scrollTo({ left: next, behavior: 'smooth' });
    }, every);

    // Once the visitor takes over, the carousel is theirs.
    track.addEventListener('pointerdown', function () { clearInterval(timer); });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('cart-drawer');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var busy = false;
    var toastTimer;
    var recsCache = { id: null, html: '' };

    /* The toast is a sibling of the panel, so it survives refresh()'s swap. */
    function stockToast(show) {
      var toast = dialog.querySelector('[data-cart-toast]');
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.hidden = !show;
      if (show) toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
    }

    /* Re-fetch the current page and copy the fresh panel + header count in.
       The server stays the single source of truth for money, totals and the
       ship bar, so there is no JS money formatter here. The empty-cart state
       lives inside the panel, so it swaps in for free when the last item goes.
       ponytail: refetching the whole page per click is intentionally simple.
       If payload size ever matters, request just this section via the Section
       Rendering API (?sections=) instead of the full document. */
    function refresh() {
      return fetch(location.pathname + location.search, { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshPanel = doc.querySelector('#cart-drawer .cart-drawer__panel');
          var livePanel = dialog.querySelector('.cart-drawer__panel');
          if (freshPanel && livePanel) livePanel.innerHTML = freshPanel.innerHTML;
          var freshCart = doc.querySelector('.ga-header__cart');
          var liveCart = document.querySelector('.ga-header__cart');
          if (freshCart && liveCart) {
            liveCart.innerHTML = freshCart.innerHTML;
            liveCart.setAttribute('aria-label', freshCart.getAttribute('aria-label'));
          }
          loadRecs();
        });
    }

    /* Inject the "Combínalo con" card from the recommendations API, keyed to the
       first cart line's product. The section renders the card server-side (money
       stays server-formatted); we only inject it. Prefer curated complementary
       products, fall back to algorithmic related ones so the card isn't empty
       out of the box. Cached per product so re-renders don't refetch. */
    function loadRecs() {
      var slot = dialog.querySelector('[data-cart-recs]');
      if (!slot || slot.innerHTML.trim()) return;
      var pid = slot.getAttribute('data-product-id');
      if (!pid || !window.fetch) return;
      if (recsCache.id === pid) { slot.innerHTML = recsCache.html; return; }
      var base = '/recommendations/products?section_id=cart-recommendations&limit=1&product_id=' + pid + '&intent=';
      fetch(base + 'complementary')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (html.indexOf('cart-drawer__rec') !== -1) return html;
          return fetch(base + 'related').then(function (r) { return r.text(); });
        })
        .then(function (html) {
          /* No card in either response (e.g. a one-product store) → inject
             nothing so :empty collapses the slot rather than showing a blank box. */
          if (html.indexOf('cart-drawer__rec') === -1) html = '';
          recsCache = { id: pid, html: html };
          slot.innerHTML = html;
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (event) {
      var stepper = event.target.closest('a.cart-drawer__step, a.cart-drawer__remove');
      if (stepper && window.fetch) {
        event.preventDefault();
        if (busy) return;
        busy = true;
        var params = new URL(stepper.href).searchParams;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(params.get('line')), quantity: Number(params.get('quantity')) })
        })
          /* Re-render the true server state whether or not the change applied,
             and toast on a 422 (e.g. the inventory ceiling). A 422 doesn't reject
             fetch and Shopify clamps the line to the real max, so refresh() shows
             the corrected qty — a visible correction, not a navigation. Navigating
             to the raw /cart/change URL as a fallback lands on an error page on
             some stores. */
          .then(function (response) {
            stockToast(!response.ok);
            return refresh();
          })
          .catch(function () {})
          .then(function () { busy = false; });
        return;
      }
      var recAdd = event.target.closest('[data-rec-add]');
      if (recAdd && window.fetch) {
        /* Add the cross-sell without leaving the drawer. No-JS falls through to
           the anchor's href (the product page). */
        event.preventDefault();
        if (busy) return;
        busy = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(recAdd.getAttribute('data-variant-id')), quantity: 1 })
        })
          .then(function () { return refresh(); })
          .catch(function () {})
          .then(function () { busy = false; });
        return;
      }
      if (event.target.closest('[data-cart-open]')) {
        event.preventDefault();
        dialog.showModal();
        loadRecs();
      } else if (event.target.closest('[data-cart-close]')) {
        dialog.close();
      } else if (event.target === dialog) {
        dialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["load-more"] && !Shopify.designMode) return;
  try {
    async function loadMore(btn) {
    if (btn.getAttribute('aria-busy')) return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(btn.href);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const sel = btn.getAttribute('data-grid');
      const grid = btn.closest('section').querySelector(sel);
      doc.querySelectorAll(sel + ' > *').forEach((el) => grid.appendChild(el));
      const wrap = btn.closest('.load-more');
      const next = doc.querySelector('.load-more');
      if (next) {
        wrap.replaceWith(next);
        io.observe(next.querySelector('[data-load-more]'));
      } else {
        wrap.remove();
      }
    } catch (err) {
      window.location.href = btn.href; /* fall back to normal navigation */
    }
  }

  /* Auto-load when the button nears the viewport; click stays as fallback. */
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        io.unobserve(e.target);
        loadMore(e.target);
      }
    }
  }, { rootMargin: '400px' });

  document.querySelectorAll('[data-load-more]').forEach((btn) => io.observe(btn));

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    io.unobserve(btn);
    loadMore(btn);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('[data-search-modal]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var input = dialog.querySelector('[data-search-input]');
    var results = dialog.querySelector('[data-search-results]');
    var url = dialog.getAttribute('data-predictive-url');
    var timer;
    var controller;

    function open() {
      if (!dialog.open) dialog.showModal();
      requestAnimationFrame(function () { input.focus(); });
    }

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });

    dialog.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });

    // Click on the dialog itself (the backdrop area) closes; clicks inside the
    // panel do not, because their target is the panel or a descendant.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      input.value = '';
      results.innerHTML = '';
      if (controller) controller.abort();
    });

    function run() {
      var q = input.value.trim();
      if (controller) controller.abort();
      if (q.length < 2) { results.innerHTML = ''; return; }

      controller = new AbortController();
      var endpoint = url + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,article,query' +
        '&resources[limit]=6';

      fetch(endpoint, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // Out-of-order guard: a slow earlier request must not overwrite the
          // results for what the user has since typed.
          if (q !== input.value.trim()) return;
          results.innerHTML = html;
        })
        .catch(function () { /* aborted or offline: leave prior results */ });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
